import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import ResearchService from "@/views/research/research.service";
import { ResearchParticipant } from "@/views/research/research.types";

@Module({ namespaced: true })
class Research extends VuexModule {
  researchParticipants: ResearchParticipant[] = [];
  selectedresearchParticipant = new ResearchParticipant();

  sortBy = '';
  sortDesc = false;
  searchQuery = '';

  private _initialState!: Record<string, any>;

  constructor(module: any) {
    super(module);
    this._initialState = { ...this };
  }

  @Action({ rawError: true })
  async fetchResearchParticipants({ timezone, clientId, show }: { timezone: string, clientId: number, show: boolean }) {
    const response = await ResearchService.GetParticipantDetails(clientId, timezone, show);
    const researchParticipants = response.map(item => ({ ...item }));
    this.context.commit("updateField", {
      path: "researchParticipants",
      value: researchParticipants
    });
  }

  @Action({ rawError: true })
  resetState() {
    for (const key of Object.keys(this._initialState)) {
      this.context.commit("updateField", {
        path: key,
        value: this._initialState[key]
      });
    }
  }
}

Research.getters = { getField };
Research.mutations = { updateField };

export default Research;